import { CurrencyPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslatableKey } from '@app/types/translatable.type';
import { TranslateModule, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { map, startWith } from 'rxjs/operators';

@Component({
    selector: 'app-tax-return-summary-details-row',
    template: `
        <label
            ><span>{{ label | translate: labelParams }}</span>
            <!-- If a child ui-badge is fed to the component, it is displayed after the label -->
            <span class="badge"><ng-content select="ui-badge" /></span
        ></label>
        <!-- If a child with class="text" is fed into the component it will be displayed INSTEAD of the amount content below-->
        <span class="text">
            <ng-content select=".text" />
        </span>
        @if (amount) {
            @if (isCurrency) {
                <span>{{ amount | currency: undefined : '' : undefined : locale() }}</span>
            } @else {
                <span>{{ amount }}</span>
            }
        } @else {
            <span>{{ 'na' | translate }}</span>
        }
    `,
    styles: [
        `
            :host {
                padding: 1rem 0;
                display: flex;
                justify-content: space-between;

                &:not(:first-of-type) {
                    border-top: 1px solid var(--table-cell-border-color);
                }
            }

            .badge {
                margin-left: 0.5rem;
                &:empty {
                    display: none;
                }
            }

            /* Hides the amount if a text child was passed in */
            .text:not(:empty) + * {
                display: none;
            }
        `,
    ],
    standalone: true,
    imports: [TranslateModule, CurrencyPipe],
})
export class TaxReturnSummaryDetailsRowComponent {
    @Input({ required: true }) label!: TranslatableKey;
    @Input() labelParams?: Parameters<TranslatePipe['transform']>[1];
    @Input() amount?: number;
    /**
     * Can be used to disable currency pipe transformation if a non-currency value is fed in via amount
     */
    @Input() isCurrency = true;

    /**
     * Ensures we always use the correct currency format according to the user's language
     */
    locale = toSignal(
        this.translateService.onLangChange.pipe(
            startWith({ lang: this.translateService.currentLang }),
            map(({ lang }) => lang)
        )
    );

    constructor(private translateService: TranslateService) {}
}
